<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-select showSearch v-model="queryParam.corpBusinessId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="计量单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
              <a-form-item label="车号">
                <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入" />
              </a-form-item>
            </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="合同号">
                <a-input v-model.trim="queryParam.contractNo" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="过磅时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button> -->
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <div class="table-operator" >
      <a-button  type="primary" @click="handleExport()">导出</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="small"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :scroll="{ x: 1950}"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="supplierName" slot-scope="text, record, index">
        {{ record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName}}
      </span>

      <span slot="upResult" slot-scope="text, record,index">
        <span v-if="!record.upResult">未上传</span>
        <span v-if="record.upResult === config.uploadResult.SUCCESS">上传成功</span>
        <span v-if="record.upResult === config.uploadResult.UPDATED">已更新</span>
        <span v-if="record.upResult === config.uploadResult.FAIL" style="color:red">
            上传失败
          <a-tooltip
            trigger="click"
            placement="topLeft"
          >
            <template slot="title">
              <span style="color:red">{{record.remark}}</span>
            </template>
            <span style="color:blue">(查看原因)</span>
           <!--  <div>
              <a-button>查看原因</a-button>
            </div> -->
          </a-tooltip>
        </span>
      </span>
  
      <span slot="action" slot-scope="text, record">
      <!--   <a @click="handleDetail(record)">详情</a>
        <a-divider v-if="record.upResult &&  record.upResult !== '3'" type="vertical" />
        <a v-if="!record.upResult || record.upResult === '2'" @click="handleUpload(record)">上传</a>
        <a v-if="record.upResult && record.upResult === '1'" @click="handleUpload(record)">重新上传</a> -->
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { codeList } from '@/api/sys'
import { corpBusinessList } from '@/api/basic'
import { orderExportPage, weighingUpload, weighingUploadInfo } from '@/api/logistics'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import storage from '@/utils/storage'
import queryMixin from '@/mixins/queryMixin'
import { exportMethod } from '@/utils/exportUtil'

export default {
  name: 'Door',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      // 高级搜索 展开/关闭
      advanced: true,
      // 查询参数
      queryParam: {},
      businessSelect:[],
      // 表头
      columns: [
        {
          title: '序号',
          width: '50px',
          scopedSlots: { customRender: 'serial' }
        }, 
        {
          title: '客户名称',
          width: '290px',
          dataIndex: 'businessName'
          //scopedSlots: { customRender: 'supplierName' },
        },
        {
          title: '品名',
          dataIndex: 'materielName'
        },
        {
          title: '合同号',
          dataIndex: 'contractNo',
          width: '170px',
        },
        {
          title: '订单单号',
          dataIndex: 'orderNo',
          width: '170px',
        },
        {
          title: '订单行号',
          dataIndex: 'code',
          width: '90px',
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '90px',
        },
        {
          title: '计量单号',
          dataIndex: 'logisticsNo',
          width: '190px',
        },
      /*   {
          title: '称重单号',
          dataIndex: 'weighingNo',
          width: '190px',
        }, */
/*         {
          title: '上传状态',
          width: '150px',
          scopedSlots: { customRender: 'upResult' },
        }, */
        {

          title: '发货数量(KG)',
          dataIndex: 'scaleNum',
          width: '110px',
        },
/*         {

          title: '剩余量(KG)',
          dataIndex: 'remainNum',
          width: '90px',
        }, */
        {
          title: '单价(元)',
          dataIndex: 'scalePrice',
          width: '90px',
        },
        {
          title: '金额(元)',
          dataIndex: 'scaleAmount',
          width: '90px',
        },
        {
          title: '发票状态',
          width: '100px',
          dataIndex: 'orderStatus',
          // scopedSlots: { customRender: 'invoiceImg' }
        },
        {
          title: '过磅时间',
          dataIndex: 'uploadTime',
          width: '160px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '120px',
          fixed: 'right',
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log(this.queryParam)
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }

        return orderExportPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 上传系统下拉
      softcodeSelect: null,
      // 上传状态
      upStatusSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()
    this.loadBusinessSelect()
    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {time:[moment().startOf('day'), moment().endOf('day')]}
    }else{
      if (this.queryParam.time && this.queryParam.time.length >0){
        this.queryParam.time[0] = moment(this.queryParam.time[0])
        this.queryParam.time[1] = moment(this.queryParam.time[1])
      }
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      this.softcodeSelect = this.$store.getters.codeList.third_party_datasource
      this.upStatusSelect = this.$store.getters.codeList.logistics_upload_status
      console.log(this.upStatusSelect)
    },
    loadBusinessSelect() {
      new Promise(resolve => {
        const data = corpBusinessList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.businessSelect = res
      })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
   
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleExport() {
      var paramData= Object.assign({}, this.queryParam)
      let exportDetail = {
        method: 'POST',
        url: this.config.downloadOrderXsUrl,
        fileName: '销售明细表.xlsx',
        data:paramData
      }
      exportMethod(exportDetail)
    },

  }
}
</script>
